import { useLocation, useNavigate } from "react-router-dom";
import { useHandleNavClickHomePage } from "../hooks/useHandleNavClick";

export default function Footer() {

  const handleNavClick  = useHandleNavClickHomePage()

  const quickLinks = [
    { name: "Join Our Community", link: "/our_community" },
    { name: "Tech Hangout", link: "/#tech-hangout" },
    { name: "Sponsors", link: "/#sponsors" },
  ];

  const socials = [
    {
      name: "Twitter",
      src: "/images/Twitter.png",
      link: "#",
      glow: "rgba(29,155,240,0.6) ",
    },
    {
      name: "Youtube",
      src: "/images/Youtube.png",
      link: "#",
      glow: "rgba(255,0,0,0.6)",
    },
    {
      name: "Instagram",
      src: "/images/Instagram.png",
      link: "https://www.instagram.com/techspacecommunity_?igsh=ZWxsOW92NjBwdjZu",
      glow: "rgba(225,48,108,0.6)",
    },
    {
      name: "Facebook",
      src: "/images/Facebook.png",
      link: "#",
      glow: "rgba(59,89,152,0.6)",
    },
  ];


  return (
    <footer className="px-4 py-12 pt-16 text-base bg-black text-secondary">
      <div className="container flex flex-col gap-8 mx-auto max-w-7xl">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex flex-col gap-4 md:flex-row md:items-center">
            <img src="/images/Logo.png" alt="Logo" className="w-40" />
            <p className="max-w-prose md:max-w-[30ch]">
              Whether you are looking for answers, resources, or a community to
              join, Tech Space has the right vibes for you.
            </p>
          </div>

          <div className="flex flex-col gap-6">
            <h4 className="text-[clamp(1.5rem,1.429rem+0.357vw,1.75rem)]">
              Quick Links
            </h4>
            <ul className="flex flex-col gap-4 md:flex-row md:items-center">
              {quickLinks.map((data, index) => (
                <li key={index}>
                  <button
                    onClick={() =>
                      handleNavClick(
                        data.name === "Tech Hangout" ? "/#tech-hangout" : data.link
                      )
                    }
                    className="relative group text-left w-full"
                  >
                    {data.name}
                    <span className="absolute left-0 -bottom-1 h-[2px] w-full bg-primary scale-x-0 group-hover:scale-x-100 transition-transform origin-left duration-300"></span>
                  </button>
                </li>
              ))}
            </ul>
          </div>

        </div>

        <div className="w-full h-[1px] bg-primary"></div>

        <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
          <p className="flex items-center gap-2">
            <img
              src="/images/Screenshot 2025-04-03 223541 1.png"
              alt="footer logo"
              className="w-10 h-10"
            />
            <span>
              &copy; TechSpace {new Date().getFullYear()}. All rights reserved.
            </span>
          </p>

          <ul className="flex items-center justify-around gap-4 md:gap-6 lg:gap-8">
            {socials.map((data, index) => (
              <li
                key={index}
                onClick={() => window.open(data.link, "_blank")}
                className="group cursor-pointer transition duration-300 ease-in-out"
              >
                <img
                  src={data.src}
                  alt={data.name}
                  className="w-6 h-6 md:w-7 md:h-7 transition duration-300 ease-in-out group-hover:scale-110"
                  style={{
                    filter: `drop-shadow(0 0 0 transparent)`,
                    transition: "filter 0.3s ease-in-out",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.filter = `drop-shadow(0 0 10px ${data.glow})`;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.filter = `drop-shadow(0 0 0 transparent)`;
                  }}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
}
